<div
    class="flex flex-column gap-3 justify-content-center pin-view-container align-content-center align-items-center text-center">
    <div>
        <span class="title">
            This secure link is no longer valid.
        </span>
    </div>
    <div>
        <span class="sub-title">
            In order to enter secure information, the agent must send another secure link.
        </span>
    </div>
</div>